import AppPageTemplate from '@/components/templates/AppPageTemplate'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const FeedLayout = () => {
  return (
    <AppPageTemplate>
      <Outlet />
    </AppPageTemplate>
  )
}

export const Route = createFileRoute('/_authenticated/_explore')({
  component: FeedLayout,
})
